import api from './client';

export interface ApprovalRecord {
  id: string;
  project_id: string;
  from_stage: string;
  to_stage: string;
  action: 'approve' | 'reject';
  comment: string | null;
  user_id: string;
  user_name: string | null;
  user_role: string | null;
  created_at: string;
}

export interface WorkflowStatus {
  project_id: string;
  current_stage: string;
  can_advance: boolean;
  can_reject: boolean;
  next_stage: string | null;
  previous_stage: string | null;
  required_role: string | null;
  approvals: ApprovalRecord[];
}

export async function getWorkflowStatus(projectId: string) {
  const res = await api.get<WorkflowStatus>(`/projects/${projectId}/workflow`);
  return res.data;
}

export async function advanceWorkflow(projectId: string, comment?: string) {
  const res = await api.post<ApprovalRecord>(`/projects/${projectId}/workflow/advance`, {
    comment: comment || null,
  });
  return res.data;
}

export async function rejectWorkflow(projectId: string, comment: string) {
  const res = await api.post<ApprovalRecord>(`/projects/${projectId}/workflow/reject`, {
    comment,
  });
  return res.data;
}

export async function getWorkflowHistory(projectId: string) {
  const res = await api.get<ApprovalRecord[]>(`/projects/${projectId}/workflow/history`);
  return res.data;
}

export async function listPendingApprovals() {
  const res = await api.get<Array<{ id: string; name: string; status: string; organization_id: string | null }>>('/workflow/pending');
  return res.data;
}
